import {
  filter,
  from,
  fromEvent,
  map,
  repeat,
  take,
  takeWhile,
  tap,
  toArray,
  zip,
} from 'rxjs'
import { isRefreshDesign, setDesign } from '@/infra/design'

/**
 * Chungus Mode: the Konami code toggles the refreshed portal design.
 */
export function chungusMode() {
  const konamiCode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]
  return zip(
    from(konamiCode),
    fromEvent<KeyboardEvent>(window.document, 'keyup').pipe(
      map((x) => x.keyCode),
    ),
  ).pipe(
    map(([left, right]) => left === right),
    takeWhile(Boolean),
    take(konamiCode.length),
    toArray(),
    // A wrong key ends the sequence early with a partial match.
    filter((arr) => arr.length === konamiCode.length),
    repeat(),
    tap(() => setDesign(isRefreshDesign ? 'classic' : 'refresh')),
  )
}
